<template>
  <b-navbar :fixed-top="true" type="is-light" class="main-nav">
    <template slot="brand">
      <b-navbar-item>
        <h1 class="title">Cirrus Separations</h1>
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item to="./documents" tag="router-link" :active="$route.path === '/documents'">
        Documents
      </b-navbar-item>
<!--      <b-navbar-item to="./pipelines" tag="router-link" :active="$route.path === '/pipelines'" :disabled="true"/>-->
      <b-navbar-item to="./" tag="router-link" :active="$route.path === '/'">
        Status
      </b-navbar-item>
    </template>
    <template slot="end">
      <b-navbar-item>
        <p>Logged in as <strong>{{username}}</strong></p>
      </b-navbar-item>
      <b-navbar-item>
        <a class="button" @click="clearToken" >
          Log out
        </a>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
  export default {
    name: "Navbar",
    computed: {
      username() {
        return this.$store.state.auth.user && this.$store.state.auth.user.username;
      }
    },
    methods: {
      clearToken() {
        this.$store.commit("auth/setToken", "");
        this.$router.push("login");
      }
    },
  }
</script>

<style scoped>
  h1 {
    display: flex;
    align-items: center;
  }

  h1 small {
    font-size: 0.5em;
    margin-left: 0.5em;
    opacity: 0.5;
  }

  .main-nav {
    z-index: 50 !important;
  }
  .navbar-start .navbar-item {
    padding: .5em 1em 0 1em;
    font-size: 1.1em;
  }
  .navbar-end .navbar-item p{
    font-size: 1.1em;
    margin: .5em 1em 0 0;
  }
</style>
